import { Box, Button, TextField, Typography } from "@mui/material";

interface SignupWithEmailProps {
  setEmail: any;
  email: string;
  setPassword: any;
  password: string;
  confirmPassword: string;
  setConfirmPassword: any;
  handleGoBack: () => void;
  handleContinue: () => void;
}

const SignupWithEmail = ({
  setEmail,
  email,
  setPassword,
  password,
  confirmPassword,
  setConfirmPassword,
  handleGoBack,
  handleContinue,
}: SignupWithEmailProps) => {
  return (
    <Box
      sx={{
        bgcolor: "surface.primary",
        color: "primary.contrastText",
        height: "100vh",
        width: "100vw",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        width={"450px"}
        flexDirection={"column"}
        alignItems={"center"}
        justifyContent={"center"}
        display={"flex"}
      >
        <Typography
          variant="h4"
          color="text.primary"
          align={"center"}
          fontWeight={600}
          letterSpacing={"0.25px"}
        >
          Continue with Email
        </Typography>
        <Typography
          variant="subtitle1"
          color="text.secondary"
          fontWeight={500}
          align={"center"}
          letterSpacing={"0.15px"}
          marginTop={0.5}
        >
          Please enter your credentials below
        </Typography>

        <Box
          width={"100%"}
          padding={3}
          color={"text.secondary"}
          bgcolor={"white"}
          borderRadius={"8px"}
          display={"flex"}
          flexDirection={"column"}
          gap={3}
          alignItems={"center"}
          marginTop={2.5}
          justifyContent={"center"}
        >
          <TextField
            required
            id="email"
            type="email"
            label="Email"
            value={email}
            onChange={(e:any)=>setEmail(e.target.value)}
            placeholder="Enter your email"
            fullWidth
          />
          <TextField
            required
            id="password"
            type="password"
            label="Password"
            value={password}
            onChange={(e:any)=>setPassword(e.target.value)}
            placeholder="Enter your password"
            fullWidth
          />
          <TextField
            required
            id="reEnterPassword"
            type="password"
            label="Re-enter Password"
             value={confirmPassword}
            onChange={(e:any)=>setConfirmPassword(e.target.value)}
            placeholder="Re-enter Password"
            fullWidth
          />

          <Box display={"flex"} gap={2} width={"100%"}>
            <Button
              variant="text"
              onClick={handleGoBack}
              color="primary"
              size="large"
              sx={{ width: "40%" }}
            >
              Go Back
            </Button>
            <Button
              variant="contained"
              onClick={handleContinue}
              color="primary"
              fullWidth
              size="large"
            >
              Continue
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default SignupWithEmail;
